import { mutations } from './trip.d';

export default {
  /**
   * Initialize Current User
   */
  [mutations.setTrips](state, trips) {
    state.trips = trips;
  }
};
